//const isPage = slug => document.body.classList.contains(slug);
import { scrollEntryAnimation } from '../helpers/scroll-entry-animation';
import { animateCountUp } from '../helpers/animate-count-up';

import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

import 'swiper/css';

export const UIController = {
  init() {
    return new Promise((resolve, reject) => {
      try {
        this.initHeaderBlur();
        this.initEntryAnimateScroll();
        this.initAnimateCountUp();
        this.initThumbCarousel();
        this.initTopicFeatureSwiper();
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  },

  initHeaderBlur() {
    const header = document.querySelector('.header');

    window.addEventListener('scroll', function () {
      if (window.scrollY > 50) {
        header.classList.add('header-blur');
      } else {
        header.classList.remove('header-blur');
      }
    });
  },

  initEntryAnimateScroll() {
    scrollEntryAnimation(); // initial run
  },

  initAnimateCountUp() {
    const animateNumberCountUp = document.querySelectorAll('.animate-count-up');

    if (!animateNumberCountUp.length) {
      return;
    }

    animateNumberCountUp.forEach((el) => {
      animateCountUp(el);
    });
  },

  initThumbCarousel() {
    const thumbContainer = document.querySelector('.thumb-container');

    if (thumbContainer) {
      new Swiper(thumbContainer, {
        modules: [Autoplay],
        slidesPerView: 2,
        spaceBetween: 30,
        loop: true,
        speed: 4000,
        autoplay: {
          delay: 0,
        },
        breakpoints: {
          300: {
            slidesPerView: 1.2,
            spaceBetween: 12,
          },
          480: {
            slidesPerView: 1.8,
            spaceBetween: 16,
          },
          640: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 28,
          },
        },
      });
    }
  },

  initTopicFeatureSwiper() {
    const customPaginationEl = document.querySelector('.topics-features-swiper-custom-pagination');
    const topicFeatureSwiperEl = document.querySelector('.topics-features-swiper');

    if (!customPaginationEl || !topicFeatureSwiperEl) {
      return;
    }

    const topicFeatureSwiper = new Swiper(topicFeatureSwiperEl, {
      loop: false,
      on: {
        slideChange: function () {
          updateActivePagination(topicFeatureSwiper.activeIndex);
        },
      },
    });

    function updateActivePagination(index) {
      document.querySelectorAll('.pagination-item').forEach((item, i) => {
        const content = item.querySelector('.pagination-content');

        if (i === index) {
          item.classList.add('active');
          content.style.maxHeight = content.scrollHeight + 'px';
        } else {
          item.classList.remove('active');
          content.style.maxHeight = 0;
        }
      });
    }

    document.querySelectorAll('.pagination-header').forEach((header, i) => {
      header.addEventListener('click', () => {
        topicFeatureSwiper.slideTo(i);
      });
    });

    updateActivePagination(0);
  },
};
